const formatTitle = {
  creation: 'Criação',
  changeStatusTrue: 'Inativado',
  changeStatusFalse: 'Reativado',
  changeMaintenanceStatusTrue: 'Retorno da manutenção',
  changeMaintenanceStatusFalse: 'Enviado para a manutenção',
  changeEquipmentModel: 'Atualização do tipo de equipamento',
  changeCompany: 'Atualização da empresa',
  changeReference: 'Atualização da referência',
  changeSerialNumber: 'Atualização do número de série',
  changeDescription: 'Atualização das especificações',
  changePlace: 'Atualização do local',
  changeSite: 'Atualização do site',
  changePhoto: 'Atualização da Foto',
  changeBrand: 'Atualização da marca do equipamento',
  changeCompanies: 'Atualização das empresas',
  default: 'Esse equipamento foi atualizado'
};

export default formatTitle;
